<template>
    <v-dialog v-model="getModalCadastroEstoque" max-width="500px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Cadastro de Estoque</v-card-title>
            <form @submit.prevent="salvar" class="px-3">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field dense outlined v-model="getEstoque.nome" label="Nome" class="ml-2 mr-2"
                                required></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field dense outlined v-model="getEstoque.descricao" label="Descrição"
                                class="ml-2 mr-2"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-checkbox v-model="getEstoque.principal" label="Principal"  class="ml-2 mr-2 mt-0 mb-0"></v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined color="default" @click="setModalCadastroEstoque(false)">Voltar</v-btn>
                    <v-btn v-if="getEstoque.id != 1 && $helper.verificaPermissao('excluir-estoque')" outlined color="error" @click="setModalExcluirEstoque(true)">Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" type="submit">Salvar</v-btn>
                </v-card-actions>
            </form>
        </v-card>
        <ModalExcluir />
    </v-dialog>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import ModalExcluir from '@/pages/estoque/ModalExcluir'
    export default {
        components: {
            ModalExcluir
        },
        computed: {
            ...mapGetters([
                'getEstoque',
                'getModalCadastroEstoque',
            ])
        },
        methods: {
            ...mapActions([
                'atualizarEstoque',
                'salvarEstoque',
                'excluirEstoque',
                'setModalCadastroEstoque',
                'setModalExcluirEstoque'
            ]),
            salvar() {
                if (this.getEstoque.id) {
                    this.atualizarEstoque(this.getEstoque)
                } else {
                    this.salvarEstoque(this.getEstoque)
                }
            }
        },
    }
</script>